import React from "react";
import { useTranslation } from "react-i18next";
import { Spinner } from "reactstrap";
import { SelectInput } from "../../common";
import { Period } from "../types";
import Chart from "./Chart";
import "./PriceChart.scss";
import _ from "lodash";
import Cookies from "js-cookie";

const availablePeriods = [
  {
    label: "averagePrices:last12months",
    value: 12,
    period: Period.monthly,
  },
  {
    label: "averagePrices:last12weeks",
    value: 3,
    period: Period.weekly,
    weekCount: 12,
  },
  {
    label: "averagePrices:last4weeks",
    value: 1,
    period: Period.weekly,
    weekCount: 4,
  },
];

const availablePeriodsDairy = [
  {
    label: "averagePrices:last36months",
    value: 36,
    period: Period.monthly,
  },
  {
    label: "averagePrices:last24months",
    value: 24,
    period: Period.monthly,
  },
  {
    label: "averagePrices:last12months",
    value: 12,
    period: Period.monthly,
  },
  {
    label: "averagePrices:last12weeks",
    value: 3,
    period: Period.weekly,
    weekCount: 12,
  },
  {
    label: "averagePrices:last4weeks",
    value: 1,
    period: Period.weekly,
    weekCount: 4,
  },
];

const unathorisedPeriod = [
  {
    label: "averagePrices:last4weeks",
    value: 1,
    period: Period.weekly,
    weekCount: 4,
  },
];

function mapTranslations(options, t) {
  if (Array.isArray(options)) {
    return options.map(option => ({
      ...option,
      label: t(option.label),
    }));
  }
  return {
    ...options,
    label: t(options.label),
  };
}

const PriceChart = ({
  option,
  onOptionChange,
  chartData,
  selectedProducts,
  type,
  typeTitle,
}) => {
  const { t } = useTranslation(["averagePrices"]);
  const [counter, setCounter] = React.useState(0);
  const token = Cookies.get("user_token");

  const isDataMissing = () => {
    // Check if there is at least one data record for chart component
    const selectedProductsKeys = selectedProducts.map(product => product.key);

    const chartDataKeys = chartData.map(data =>
      selectedProductsKeys.map(key => data[key])
    );

    const isAllNull = data => {
      return _.every(data, _.isNil);
    };

    const existingChartDataKeys = chartDataKeys.filter(
      data => data !== undefined
    );

    if (existingChartDataKeys.length === 0) {
      return true;
    }
    return (
      existingChartDataKeys.length > 0 &&
      existingChartDataKeys.filter(data => {
        if (Array.isArray(data)) {
          return !isAllNull(data);
        }
        return data !== undefined;
      }).length === 0
    );
  };

  React.useEffect(() => {
    setCounter(counter + 1);
  }, [chartData]);

  if (isDataMissing()) return null;

  return (
    <div className="PriceChart">
      <div className="header">
        <h2 className="header__title">
          {t("averagePrices:chartTitle")} {typeTitle}
        </h2>
      </div>
      <div className="section">
        <div className="header__select">
          {token && (
            <>
              <p className="label">
                {t("averagePrices:widget:chartSelectTitle")}
              </p>

              <SelectInput
                value={mapTranslations(option, t)}
                options={
                  token
                    ? mapTranslations(
                        type === "dairy"
                          ? availablePeriodsDairy
                          : availablePeriods,
                        t
                      )
                    : mapTranslations(unathorisedPeriod, t)
                }
                onChange={value => onOptionChange(value)}
                hasIn18nLabel
              />
            </>
          )}
        </div>
        <Chart
          key={counter} // this should fix "ivisible" on the chart when component re-renders
          data={chartData}
          products={selectedProducts}
          period={option.period}
        />
      </div>
    </div>
  );
};

const Loader = () => (
  <div className="PriceChart">
    <div className="spinner-wrapper">
      <Spinner />
    </div>
  </div>
);

PriceChart.Loader = Loader;

export default PriceChart;

export { availablePeriods, Period, availablePeriodsDairy };
